module.exports = __webpack_public_path__ + "static/media/iphone-7-white.9fe82dbd.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/iphone-7-white.png
// module id = 19
// module chunks = 0